<template>
  <div style="display: flex; margin-bottom: 10px">
    <h2>Configuración adicional</h2>
  </div>
  <div style="display: flex">
    <el-button
      type="primary"
      size="default"
      @click="handleDialogVisible('AdditionalSettingsConcepts', 'Conceptos')"
      >Conceptos</el-button
    >
    <el-button
      type="primary"
      size="default"
      @click="handleDialogVisible('AdditionalSettingsDeposits', 'Depósitos')"
      >Depósitos</el-button
    >
    <el-button
      type="primary"
      size="default"
      @click="handleDialogVisible('AdditionalSettingsReceiptBooks', 'Talonarios')"
      >Talonarios</el-button
    >
    <el-button
      type="primary"
      size="default"
      @click="handleDialogVisible('AdditionalSettingsLocations', 'Ubicaciones')"
      >Ubicaciones</el-button
    >
  </div>

  <additional-settings-modal
    v-if="currentComponent !== null"
    :visible="dialogVisible"
    :component="currentComponent"
    :title="modalTitle"
    :width="dialogWidth"
    @closeModal="handleCloseModal"
  />
</template>

<script setup>
import { ref } from 'vue';
import AdditionalSettingsModal from './additional_settings_modal.vue';

const dialogVisible = ref(false);
const modalTitle = ref('Configuracion adicional');
const currentComponent = ref(null);
const dialogWidth = ref(500);

const handleDialogVisible = (component, title) => {
  currentComponent.value = component;
  modalTitle.value = title;
  dialogVisible.value = true;
};

const handleCloseModal = () => {
  dialogVisible.value = false;
};
</script>
